import { Modal, Stepper, Text } from "@mantine/core";
import QuoteLink from "../../QuoteLink/QuoteLink";
import WizardHeader from "./WizardHeader";
import WizardFooter from "./WizardFooter";
import SummaryRail from "./SummaryRail";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepFour from "./StepFour";
import classes from "./SingleIssuanceWizard.module.css";

const WizardShell = ({
  wizard,
  issueAs,
  onIssueAsChange,
  selectedOperator,
  setSelectedOperator,
  operatorMeta,
  onOperatorMeta,
  onUrlReady,
  tripPreview,
  onTripPreview,
  quoteData,
  filteredCovers,
  coverOption,
  onCoverChange,
  couponCode,
  setCouponCode,
  applyCoupon,
  isCouponApplying,
  isCouponApplied,
  originalAmount,
  discountedAmount,
  finalAmount,
  onContinue,
  showTravelerForm,
  showQuoteLink,
  openQuoteLink,
  closeQuoteLink,
  isSubmitting,
  handleTraveler,
}) => {
  const { activeStep, steps, canProceed, nextStep, prevStep, goToStep } = wizard;

  const handleNext = () => {
    if (activeStep === 1) onContinue();
    nextStep();
  };

  const stepPanel = (stepIndex, content) => (
    <div className={classes.stepPanel} hidden={activeStep !== stepIndex}>
      {content}
    </div>
  );

  return (
    <div className={classes.shell}>
      <WizardHeader />

      <div className={classes.stepperWrap}>
        <Stepper active={activeStep} color="brand" size="sm" visibleFrom="sm">
          {steps.map((step) => (
            <Stepper.Step
              key={step.label}
              label={step.label}
              description={step.description}
            />
          ))}
        </Stepper>
        <Text className={classes.mobileStep}>
          {steps[activeStep].label} · Step {activeStep + 1} of {steps.length}
        </Text>
      </div>

      <div className={classes.grid}>
        <main className={classes.main}>
          <div className={classes.card}>
            <div className={classes.stepContent}>
              {stepPanel(
                0,
                <StepOne
                  issueAs={issueAs}
                  onIssueAsChange={onIssueAsChange}
                  selectedOperator={selectedOperator}
                  setSelectedOperator={setSelectedOperator}
                  onOperatorMeta={onOperatorMeta}
                  onUrlReady={onUrlReady}
                  onTripPreview={onTripPreview}
                />
              )}

              {quoteData &&
                stepPanel(
                  1,
                  <StepTwo
                    quoteData={quoteData}
                    filteredCovers={filteredCovers}
                    coverOption={coverOption}
                    onCoverChange={onCoverChange}
                    couponCode={couponCode}
                    setCouponCode={setCouponCode}
                    applyCoupon={applyCoupon}
                    isCouponApplying={isCouponApplying}
                    isCouponApplied={isCouponApplied}
                    originalAmount={originalAmount}
                    discountedAmount={discountedAmount}
                  />
                )}

              {quoteData && coverOption && showTravelerForm &&
                stepPanel(
                  2,
                  <StepFour
                    quoteData={quoteData}
                    coverOption={coverOption}
                    isSubmitting={isSubmitting}
                    handleTraveler={handleTraveler}
                    defaultTourOperatorName={
                      issueAs === "Operator" ? operatorMeta?.name : ""
                    }
                  />
                )}
            </div>
          </div>
        </main>

        <aside className={classes.rail}>
          <SummaryRail
            quoteData={quoteData}
            tripPreview={tripPreview}
            coverOption={coverOption}
            filteredCovers={filteredCovers}
            finalAmount={finalAmount}
            originalAmount={originalAmount}
            discountedAmount={discountedAmount}
            isCouponApplied={isCouponApplied}
            onEditTrip={() => goToStep(0)}
            activeStep={activeStep}
          />
        </aside>
      </div>

      <WizardFooter
        activeStep={activeStep}
        stepsCount={steps.length}
        canNext={canProceed[activeStep]}
        onBack={prevStep}
        onNext={handleNext}
        showGenerateLink={activeStep === 1 && Boolean(coverOption)}
        onGenerateLink={openQuoteLink}
      />

      <Modal
        opened={showQuoteLink}
        onClose={closeQuoteLink}
        title="Generate quote link"
        size="lg"
        centered
      >
        {quoteData && coverOption && (
          <QuoteLink quoteData={quoteData} coverOption={coverOption} />
        )}
      </Modal>
    </div>
  );
};

export default WizardShell;
